const collection = {
    slug: "comme-des-garcons-homme-plus-2026ss-not-suits-but-suits-guide",
    metaTitle:
      "コムデギャルソンオムプリュス 2026SSとは｜Not Suits, But Suitsと買取・レンタルガイド",
    metaDescription:
      "COMME des GARÇONS HOMME PLUS 2026SS『Not Suits, But Suits』を解説。川久保玲がテーラードスーツをベースに、18世紀ロココから続く男性服の原型を解体し、ジッパーやオプティカル柄で再構成した最新コレクション。2026SSアイテムの買取相談、HOMME PLUSのレンタル、ブランド一覧への導線までEnclopediaが詳しく案内します。",
    metaKeywords:
      "コムデギャルソンオムプリュス 2026SS,COMME des GARCONS HOMME PLUS 2026SS,Not Suits But Suits,コムデギャルソンオムプリュス Not Suits But Suits,コムデギャルソンオムプリュス 買取,COMME des GARCONS HOMME PLUS 買取,コムデギャルソンオムプリュス レンタル,COMME des GARCONS HOMME PLUS レンタル,コムデギャルソンオムプリュス スーツ,コムデギャルソンオムプリュス テーラード,コムデギャルソンオムプリュス アーカイブ,コムデギャルソンオムプリュス 名作,川久保玲 スーツ,コムデギャルソン 買取,COMME des GARCONS 買取,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/comme-des-garcons-homme-plus-2026ss-not-suits-but-suits-guide",
    heroImage:
      "media/archive_fashion/archive15.png",
    heroImageAlt:
      "COMME des GARÇONS HOMME PLUS 2026SS Not Suits But Suitsを解説するEnclopediaアーカイブガイド画像",
    heroNumber: "15 / NOT SUITS, BUT SUITS",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "COMME des GARÇONS HOMME PLUS 2026SS『Not Suits, But Suits』",
    lead:
      "COMME des GARÇONS HOMME PLUS 2026SS『Not Suits, But Suits』。\n\n直訳すれば、“スーツではない、しかしスーツ”。\nこの矛盾したタイトルに、HOMME PLUSが長く向き合ってきた男性服への問いが凝縮されています。\n\nブランドが重きを置いてきたテーラードスーツをベースにしながら、ショーが進むにつれてその構造は解体されていく。\nオプティカルな小紋柄、タイトなシルエット、18世紀ロココ時代から続く男性服の原型、現代的なジッパー。\n\nスーツは社会性や秩序を象徴する服です。\nしかし川久保玲は、そのスーツを“正しく着る服”としてではなく、壊し、開き、別の身体へ変形させる装置として提示しました。\n\nEnclopediaでは、この2026SSを、最新コレクション情報として消費するのではなく、HOMME PLUSのアーカイブ価値と買取・レンタル導線へつながる入口として読み解きます.",
    keywordLine: [
      "not suits but suits",
      "tailoring",
      "homme plus buyback",
      "archive rental",
    ],
    thesis:
      "2026SS『Not Suits, But Suits』の重要性は、スーツを否定するのではなく、スーツという男性服の原型を解体しながら、それでもなお“スーツらしさ”を残した点にあります。",
    whyTitle:
      "なぜ“スーツではない、しかしスーツ”なのか。",
    whyBody:
      "スーツは、男性服の中でも最も制度的な服です。\n仕事、礼装、社会性、階級、秩序、正しさ。\nジャケット、ラペル、パンツ、シャツ、ネクタイ。\nそれぞれの要素が、長い時間をかけて“男性らしい装い”の形式を作ってきました。\n\nCOMME des GARÇONS HOMME PLUSは、これまでもそのスーツを何度も問い直してきたブランドです。\nしかし2026SS『Not Suits, But Suits』では、スーツを単に崩すだけではありません。\n\n序盤では、オプティカルな小紋柄のテキスタイルとタイトなシルエットによって、スーツの形式がまだ保たれています。\nしかしショーが進むにつれて、スーツは解体され、18世紀ロココ時代から続く男性服の原型が壊されながら、ジッパーという現代的な構造によって再び形作られていく。\n\nこれは、“スーツをやめる”コレクションではありません。\nむしろ、スーツがどこまで壊れてもスーツであり続けるのかを試すコレクションです。\n\nEnclopediaでは、このような文脈を入口に、2026SSの買取相談、COMME des GARCONS HOMME PLUS全体のレンタル体験、そしてブランドページへの導線を設計します。",
    pillars: [
      {
        number: "01",
        title: "SUIT AS INSTITUTION",
        text:
          "スーツは、男性服の中でも最も制度的な服です。COMME des GARCONS HOMME PLUS 2026SSは、その制度性を土台にしながら、スーツの輪郭を解体していきます。",
      },
      {
        number: "02",
        title: "DECONSTRUCTION WITH TAILORING",
        text:
          "解体されているのに、完全には崩壊しない。ジッパー、切替、重なりによって、スーツは壊されながら新しい構造へ変換されます。",
      },
      {
        number: "03",
        title: "BUYBACK FIRST, RENTAL NEXT",
        text:
          "2026SSは今後市場に流通し始める最新アーカイブ候補です。Enclopediaでは、買取相談を入口に、COMME des GARCONS HOMME PLUS全体のレンタル体験へも接続します。",
      },
    ],
    readingTitle:
      "スーツ、ロココ、ジッパー、解体から読む『Not Suits, But Suits』。",
    readingIntro:
      "このコレクションは、単に変わったスーツを並べたものではありません。なぜスーツなのか、なぜ解体されるのか、なぜロココ的な男性服の原型と現代的なジッパーが接続されるのかを見ることで、COMME des GARCONS HOMME PLUSらしい男性服への問いが見えてきます。",
    observations: [
      {
        index: "01",
        title: "スーツは、男性服の制度そのものだった",
        text:
          "スーツは、ただのジャケットとパンツではありません。\n社会に出る服であり、仕事の服であり、礼装であり、男性性を整えるための服です。\n\n肩を作り、胸を整え、身体を社会的に見せる。\nその意味でスーツは、男性服の中でも最も形式的で、最も制度的な服だと言えます。\n\nCOMME des GARCONS HOMME PLUSがこのスーツを扱うとき、そこには必ず問いがあります。\n男性服は本当にこの形でなければならないのか。\nスーツはどこまで壊れてもスーツなのか。\n2026SSは、その問いを正面から扱ったコレクションです.",
      },
      {
        index: "02",
        title: "序盤のタイトなスーツは、崩壊前の秩序として機能する",
        text:
          "FASHIONSNAPが触れているように、序盤ではオプティカルな小紋柄のテキスタイルとタイトなシルエットが展開されます。\nここではまだ、スーツの輪郭は比較的明確です。\n\n身体に近いシルエット。\n視覚を揺らす柄。\n形式としてのジャケットとパンツ。\n\nこの“まだスーツである状態”があるからこそ、後半で起こる解体が強く見えます。\n秩序を最初に見せ、その後に壊していく。\n2026SSの構成は、スーツの変形過程そのものとして読むことができます.",
      },
      {
        index: "03",
        title: "18世紀ロココの男性服は、現代スーツの遠い記憶として現れる",
        text:
          "2026SSでは、18世紀ロココ時代から続く男性服の原型が壊されながら再構成されます。\nロココ期の男性服は、現代のスーツとは異なり、装飾性、身体の演出、階級性を強く持っていました。\n\nつまり、COMME des GARCONS HOMME PLUSは現代のビジネススーツだけを見ているのではありません。\nそのさらに奥にある、男性服が社会的な役割や権力をまとうために作られてきた歴史まで掘り返しています。\n\nスーツの原型を壊すことは、男性服の歴史そのものを問い直すことでもあります.",
      },
      {
        index: "04",
        title: "ジッパーは、クラシックなスーツを現代的に開く装置である",
        text:
          "このシーズンで重要なのが、現代的なジッパー使いです。\nジッパーは、クラシックなテーラリングに本来あまり馴染まないディテールです。\n閉じる、開く、分断する、接続する。\n\nジャケットやパンツの構造にジッパーが入り込むことで、スーツは固定された形式ではなく、開閉可能な構造へ変わります。\n\nこれは単なる装飾ではありません。\nスーツを一度閉じた制度としてではなく、開かれた構造として扱うためのディテールです.",
      },
      {
        index: "05",
        title: "“Not Suits”でありながら、完全には“Not”にならない",
        text:
          "このコレクションの面白さは、スーツが壊されているのに、完全にスーツではなくなるわけではない点です。\nラペル、ジャケット、パンツ、シャツ、テーラードの記憶。\nそれらは断片化されても残り続けます。\n\nつまり、これはスーツの否定ではありません。\nスーツという形式が、どこまで変形されても識別可能であり続けるのかを試すコレクションです。\n\n“Not Suits, But Suits”というタイトルは、その矛盾を正確に示しています.",
      },
      {
        index: "06",
        title: "日爪ノブキの帽子が、スーツの形式をさらにずらす",
        text:
          "FASHIONSNAPは、キャップとキャスケットなど異なるデザインを一つにしたような帽子を、ハットデザイナーの日爪ノブキが手掛けたと紹介しています。\n\nこの帽子も、コレクション全体のテーマと接続しています。\n帽子という小さなアイテムの中でも、異なる形式が一つにまとめられている。\n\nスーツだけでなく、頭部の装いにおいても“これは何なのか”という曖昧さが作られています。\nCOMME des GARCONS HOMME PLUSらしい違和感は、服だけでなく全身の構造に及んでいます.",
      },
      {
        index: "07",
        title: "2026SSは、最新でありながらすでにアーカイブ候補である",
        text:
          "2026SSは、現時点では最新コレクションに近い存在です。\nしかしCOMME des GARCONS HOMME PLUSにおいて、スーツをめぐる問いはブランド史の中心にあります。\n\n男性服の制度、テーラード、身体、歴史、解体。\nこれらを扱ったシーズンは、時間が経ってからアーカイブ価値が見直されやすい領域です。\n\nEnclopediaでは、2026SSを単なる新作情報としてではなく、将来的なアーカイブ候補として見ます。\n買取相談では、タグ、シーズン、ルックとの近さ、状態、サイズ、素材を含めて確認します.",
      },
      {
        index: "08",
        title: "レンタルで分かるのは、スーツが崩れる身体感覚",
        text:
          "COMME des GARCONS HOMME PLUSのスーツは、画像だけで見ると“変形した服”として見えます。\nしかし実際に着ると、肩の位置、ジッパーの開き方、パンツの落ち方、柄の視覚効果、身体との距離が分かります。\n\nスーツが身体を整えるのではなく、身体の周囲でずれ、開き、別の構造を作る。\nその感覚は、実物体験と相性がいい。\n\nEnclopediaでは、記事で背景を読み、レンタルで身体感覚として確かめる導線を作ります.",
      },
    ],
    quote:
      "Not Suits, But Suitsは、スーツの否定ではない。スーツがどこまで壊れてもスーツであり続けるのかを問うコレクションです。",
    perspectiveTitle:
      "Enclopediaは、COMME des GARCONS HOMME PLUSを“見る服”ではなく“着て理解する男性服の実験”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "BUYBACK FIRST",
        text:
          "2026SSは今後流通が始まる最新アーカイブ候補です。Enclopediaでは、COMME des GARCONS HOMME PLUS 2026SSの買取相談を、シーズン文脈込みで受け付けます。",
      },
      {
        number: "02",
        title: "RENTAL EXPERIENCE",
        text:
          "COMME des GARCONS HOMME PLUSのスーツは、実際に着ることで理解が深まります。構造、重心、柄、ジッパー、身体との距離をレンタルで体験できる導線へつなげます。",
      },
    ],
    experienceTitle:
      "COMME des GARCONS HOMME PLUS 2026SSを売る前に、そのスーツがどの文脈にあるかを確認する。",
    experienceBody:
      "COMME des GARCONS HOMME PLUS 2026SSの買取では、ブランド名だけでなく、シーズン、テーマ、ルック、素材、状態、サイズ、現在の需要が重要です。\n今回の記事では『Not Suits, But Suits』を中心に解説していますが、Enclopediaが見ているのは2026SSだけではありません。\nCOMME des GARÇONS HOMME PLUS全般、COMME des GARÇONS、COMME des GARÇONS HOMME、JUNYA WATANABE、noir kei ninomiyaなど、コムデギャルソン全体を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n\n最新コレクションを知ることは、これから市場に出てくる一着の価値を早く見極める入口になります.",
    experienceItems: [
      "COMME des GARCON HOMME PLUS 2026SSのタグ・シーズンを確認する",
      "Not Suits, But Suitsに近いスーツ、ジャケット、パンツ、ジッパー使いを撮影する",
      "オプティカル柄、小紋柄、タイトシルエット、解体的なディテールを確認する",
      "日爪ノブキによる帽子や付属品がある場合は一緒に撮影する",
      "サイズ・状態・購入時期・付属品を確認する",
      "2026SSか不明な場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "2026SSを入口に、COMME des GARCON HOMME PLUSの買取・レンタルへつなげる。",
    archiveItemsBody:
      "Enclopediaでは、COMME des GARÇONS HOMME PLUSを単なるブランド古着としてではなく、川久保玲の男性服への問い、シーズン背景、現在の需要まで含めて見ています。この記事で2026SSの重要性に触れた方は、所有しているHOMME PLUSの一着も、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "COMME des GARÇONS HOMME PLUS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons-homme-plus",
        productImage: "",
        text:
          "2026SS Not Suits, But Suitsを含むCOMME des GARCON HOMME PLUSのジャケット、パンツ、スーツ、シャツ、シーズンテーマの強いアーカイブまで。オムプリュスの買取対象と査定視点を確認できます。",
      },
      {
        label: "RENTAL FOCUS 02",
        title: "レンタルできるCOMME des GARCON HOMME PLUSを見る",
        productPath:
          "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
        productImage: "",
        text:
          "COMME des GARCON HOMME PLUSのシーズン性やシルエットは、実際に着ることで理解が深まります。Enclopediaでコムデギャルソンオムプリュスのアーカイブを体験できます。",
      },
      {
        label: "BRAND FOCUS 03",
        title: "COMME des GARÇONS HOMME PLUSブランド一覧へ",
        productPath:
          "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
        productImage: "",
        text:
          "2026SSだけでなく、COMME des GARCON HOMME PLUSのテーラード、パンツ、シャツ、シーズンテーマの強いアイテムを一覧で確認できます。",
      },
    ],
    finalCta: {
      title:
        "Not Suits, But Suitsを読んだら、次はCOMME des GARCON HOMME PLUSの価値を相談する。",
      body:
        "COMME des GARÇONS HOMME PLUS 2026SSは、スーツを否定するのではなく、スーツという男性服の原型を解体しながら再構成したシーズンです。\nEnclopediaでは、2026SSの買取相談を入口に、HOMME PLUS全体のレンタル体験やブランド一覧へつなげます。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
      buttonLabel: "COMME des GARCON HOMME PLUSをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;